export default __webpack_public_path__ + "static/media/cunningstrike1.4e35661e.png";